/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RetractCustomerBioRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/retract_customer_bio.pb'
import {RetractCustomerBioResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/retract_customer_bio.pb'


export const retractCustomerBio = (request: RetractCustomerBioRequest, options?: CashRequestOptions) => post<RetractCustomerBioRequest, RetractCustomerBioResponse>("/2.0/cash/retract-customer-bio", request, {...options, rejectOnError: true })